import { render, staticRenderFns } from "./Professionals.vue?vue&type=template&id=945857b2&"
import script from "./Professionals.vue?vue&type=script&lang=js&"
export * from "./Professionals.vue?vue&type=script&lang=js&"
import style0 from "./Professionals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports